import React, { useEffect, useState } from "react";
import { tryFetch } from "../../../Helpers/FetchAPI";
import "../../../styles/mpGallery.scss";
import { useParams } from "react-router-dom";

interface Media {
  id: string;
  file_name: string;
  file_type: string;
  file_url: string;
}

export default function MpGallery() {
  const { merchant_slug } = useParams();

  const [merchantId, setMerchantId] = useState<string | null>(null);
  const [media, setMedia] = useState<Media[]>([]);
  const [loading, setLoading] = useState(true);
  const [zoomItem, setZoomItem] = useState<Media | null>(null);

  const fetchMerchantId = async () => {
    const res = await tryFetch({ url: "/merchants", method: "GET" });
    if (res?.is_success && Array.isArray(res.data)) {
      const merchant = res.data.find((m: any) => m.merchant_slug === merchant_slug);
      if (merchant) setMerchantId(merchant.id);
    }
  };

  const fetchMedia = async (id: string) => {
    setLoading(true);
    try {
      const res = await tryFetch({
        url: `/stores/${id}/media`,
        method: "GET",
      });

      const mediaArray: Media[] = Array.isArray(res) ? res : [];
      setMedia(mediaArray);

    } catch (err) {
      console.error("fetchMedia error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchantId();
  }, [merchant_slug]);

  useEffect(() => {
    if (!merchantId) return;
    fetchMedia(merchantId);
  }, [merchantId]);

  return (
    <div className="mp-gallery">
      {loading ? (
        <p>Loading gallery...</p>
      ) : media.length === 0 ? (
        <p>No gallery images yet.</p>
      ) : (
        <div className="mp-gallery-grid">
          {media.map((item) => (
            <div
              className="mp-gallery-item"
              key={item.id}
              onClick={() => setZoomItem(item)}
            >
              {item.file_type.startsWith("image") ? (
                <img src={item.file_url} alt="Gallery" loading="lazy" />
              ) : (
                <video
                  src={item.file_url}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                />
              )}
            </div>
          ))}
        </div>
      )}

      {zoomItem && (
        <div className="mp-gallery-modal" onClick={() => setZoomItem(null)}>
          <div className="mp-gallery-modal-content">
            {zoomItem.file_type.startsWith("image") ? (
              <img src={zoomItem.file_url} alt="Zoom" />
            ) : (
              <video src={zoomItem.file_url} loop controls autoPlay />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
